import DashboardAlerts from "@/components/dashboard/DashboardAlerts.vue";
import {
  isMonitoringEnabled,
  areFollowupsRestrictedForBackoffice,
} from "@/services/config";
import store from "@/store";

const canAccessFollowups = () => {
  if (!isMonitoringEnabled) return false;
  if (areFollowupsRestrictedForBackoffice) {
    return (
      !store.getters.isAdmin &&
      !store.getters.isAssistant &&
      !store.getters.isManager
    );
  }
  return true;
};

const dashboardAlertsRoutes = [
  {
    path: "/dashboard-alerts",
    name: "dashboard-alerts",
    meta: {
      condition: canAccessFollowups,
      redirectTo: { name: "home" },
    },
    component: DashboardAlerts,
  },
];

export default dashboardAlertsRoutes;
